"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WarningIcon = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const IconContainer_1 = __importDefault(require("../IconContainer/IconContainer"));
const WarningIcon = (_a) => {
    var { className, size, title } = _a, props = __rest(_a, ["className", "size", "title"]);
    return (react_1.default.createElement(IconContainer_1.default, Object.assign({ className: (0, classnames_1.default)("gerudo-icon-warning", size, className) }, props),
        react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", version: "1.0", viewBox: "0 0 128 113.948", role: "img", "aria-label": title },
            react_1.default.createElement("title", null, title),
            react_1.default.createElement("path", { vectorEffect: "non-scaling-stroke", shapeRendering: "geometricPrecision", fillRule: "evenodd", d: "M78.455,8.277l47.233,80.415a16.765,16.765,0,0,1-14.456,25.256H16.765A16.765,16.765,0,0,1,2.309,88.692L49.543,8.277a16.765,16.765,0,0,1,28.912,0Z", role: "presentation" }),
            react_1.default.createElement("path", { vectorEffect: "non-scaling-stroke", shapeRendering: "geometricPrecision", fillRule: "evenodd", d: "M64,78.974a11,11,0,1,1-11,11A11,11,0,0,1,64,78.974Z", role: "presentation" }),
            react_1.default.createElement("path", { vectorEffect: "non-scaling-stroke", shapeRendering: "geometricPrecision", fillRule: "evenodd", d: "M64,20.974A10.954,10.954,0,0,1,75,31.858c0,3.826-4.215,28.674-6.261,37.74A1.773,1.773,0,0,1,67,70.974H61A1.779,1.779,0,0,1,59.265,69.6c-.778-3.44-1.867-9.15-2.919-15.122l-.568-3.271C54.283,42.478,53,33.969,53,31.858A10.956,10.956,0,0,1,64,20.974Z", role: "presentation" }))));
};
exports.WarningIcon = WarningIcon;
WarningIcon.defaultProps = {
    title: "Warning",
};
exports.default = WarningIcon;
//# sourceMappingURL=Warning.js.map